export default {"src":"/_next/static/media/black-room-names.5d218595.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};